import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Image, Optional } from '@honda-canada/design-system-react';
const CustomizationSummarySectionCardImage = ({ src, alt, fallbackSrc, }) => {
    const [imageError, setImageError] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Optional, { when: imageError || !src, children: _jsx(Image, { src: fallbackSrc, alt: alt, "data-testid": "cy-bap-summary-no-asset-image" }) }), _jsx(Optional, { when: !imageError && src, children: _jsx(Image, { src: src, alt: alt, onError: () => setImageError(true), onLoad: () => setImageError(false), "data-testid": "cy-bap-summary-image" }) })] }));
};
export default CustomizationSummarySectionCardImage;
